import type { McpServerType, McpConnector } from '@server/mcp';
import { useSweepApi } from '../sweep/useSweepApi';
import { useCallback } from 'react';

export const useMcpConnectorsApiFacade = () => {
  const sweepApi = useSweepApi();

  return {
    getConnectors: useCallback(async (): Promise<McpConnector[]> => {
      const response = await sweepApi.get('/mcp-connectors');
      return response.data;
    }, [sweepApi]),

    post_connector: useCallback(
      async (serverType: McpServerType, serverUrl?: string): Promise<McpConnector> => {
        const response = await sweepApi.post(`/mcp-connectors/${serverType}`, {
          ...(serverUrl && { serverUrl }),
        });
        return response.data;
      },
      [sweepApi],
    ),

    delete_connector: useCallback(
      async (serverId: string): Promise<void> => {
        await sweepApi.delete(`/mcp-connectors/${serverId}`);
      },
      [sweepApi],
    ),

    getOAuthUrl: useCallback(
      async (serverId: string): Promise<{ url: string }> => {
        const response = await sweepApi.get(`/mcp-connectors/${serverId}/oauth/url`);
        return response.data;
      },
      [sweepApi],
    ),

    handleOAuthCallback: useCallback(
      async (serverId: string, code: string): Promise<void> => {
        await sweepApi.post(`/mcp-connectors/${serverId}/oauth/callback`, { code });
      },
      [sweepApi],
    ),

    deleteConnection: useCallback(
      async (connectionId: string): Promise<void> => {
        await sweepApi.delete(`/mcp-connectors/connections/${connectionId}`);
      },
      [sweepApi],
    ),
  };
};
